const userEmotionIntervalConfig = {
  USER_EMOTION_INTERVAL_DURATION_MS: parseInt(
    process.env.REACT_APP_USER_EMOTION_INTERVAL_DURATION_MS ?? 60_000,
    10
  )
};

export default userEmotionIntervalConfig;
